/*
Author: Atul Vasudevan
Story: ENT-2317
 */
import {Component, EventEmitter, Input, OnInit, ViewChild} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {WarningModalService} from "../../../../services/warning-modal/warning-modal.service";
import {AbstractModalComponent} from "../../../abstract-modal/abstract-modal.component";
import {ConstantsService} from "../../../../services/constants/constants.service";
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { BulkUploadComponent } from '../bulk-upload/bulk-upload.component';
import {ReferenceBulkUploadComponent} from "../reference-bulk-upload/reference-bulk-upload.component";

@Component({
  selector: 'app-xref-bulk-upload-modal',
  templateUrl: './xref-bulk-upload-modal.component.pug',
  styleUrls: ['./xref-bulk-upload-modal.component.scss'],
  standalone: false
})
export class XrefBulkUploadModalComponent extends AbstractModalComponent implements OnInit {
  public bulkRequestData: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('requestForm', {static: false}) requestForm: any;
  @ViewChild(BulkUploadComponent) bulkUpload!: BulkUploadComponent;
  @ViewChild(ReferenceBulkUploadComponent) rbulkUpload!: ReferenceBulkUploadComponent;
  @Input() checkType: any;
  @Input() selectedBackgroundCheck: any;
  @Input() selectedFlow: any;
  numberOfChecks = 0;
  total = 0;
  buttonCheck = true;
  draftResponse = {};
  templateLink = '';
  flowName!: string;
  referenceCheck = ConstantsService.REFERENCE_CHECK;
  exitCheck = ConstantsService.EXIT_CHECK;
  pulseCheck = ConstantsService.PULSE_CHECK;
  backgroundCheck = ConstantsService.BACKGROUND_CHECK;
  TRUST_1101_CENTRIC = false;
  TRUST_1225_WWCC = false;
  TRUST_1337_DIRECTORSHIP_CREDIT_CHECKS = false;
  private static readonly CENTRIC_BULK_UPLOAD_BASE =
    'https://assets.xref.com/omni/bulk-upload/feature-flag-trust-1101-certn-centric-api';
  private static readonly TRUST_1337_BULK_UPLOAD_BASE =
    'https://assets.xref.com/omni/bulk-upload/feature-flag-trust-1337-directorship-credit-checks';

  constructor(public _bsModalRef: BsModalRef,
              public modal: WarningModalService,
              public permissions: PermissionsService
    ) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.TRUST_1101_CENTRIC = this.permissions.isFeatureActivated('trust-1101-centric');
    if(this.selectedBackgroundCheck?.short_name === 'mobile_id' && this.selectedBackgroundCheck?.short_name === this.selectedFlow?.parent_short)
    {
        this.selectedBackgroundCheck.short_name = this.selectedFlow.short_name
    }
    if (this.checkType === ConstantsService.EXIT_CHECK) this.templateLink = 'https://assets.xref.com/omni/bulk-upload/feature-flag/bulk-request-template-exit.csv'
    else if (this.checkType === ConstantsService.REFERENCE_CHECK) this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-reference.csv';
    else if (this.checkType === ConstantsService.PULSE_CHECK) this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-pulse.csv';
    else if (this.checkType === ConstantsService.BACKGROUND_CHECK) {
      this.setBackgroundCheckTemplateLink();
    }
  }

  setBackgroundCheckTemplateLink() {
    switch (this.selectedBackgroundCheck?.short_name) {
      case ConstantsService.ICRC_SHORT_NAME:
        this.templateLink = this.TRUST_1101_CENTRIC
          ? `${XrefBulkUploadModalComponent.CENTRIC_BULK_UPLOAD_BASE}/bulk-request-template-certn-intl-criminal-history.csv`
          : 'https://assets.xref.com/omni/bulk-upload/feature-flag-trust-276-post-send-request/bulk-request-template-certn-intl-criminal-history.csv';
        break;
      case ConstantsService.ACIC_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/feature-flag-trust-276-post-send-request/bulk-request-template-certn-au-criminal-history.csv';
        break;
      case ConstantsService.USCRC_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/feature-flag-trust-276-post-send-request/bulk-request-template-certn-us-criminal-history.csv';
        break;
      case ConstantsService.CACRC_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/feature-flag-trust-276-post-send-request/bulk-request-template-certn-ca-criminal-history.csv';
        break;
      case ConstantsService.UKDBSC_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/feature-flag-trust-276-post-send-request/bulk-request-template-certn-uk-dbs.csv';
        break;
      case ConstantsService.UKDSC_SHORT_NAME:
        this.templateLink = this.TRUST_1101_CENTRIC
          ? `${XrefBulkUploadModalComponent.CENTRIC_BULK_UPLOAD_BASE}/bulk-request-template-certn-uk-ds.csv`
          : 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-certn-uk-ds.csv';
        break;
      case ConstantsService.ID_ONE_DOC_SHORT_NAME:
      case ConstantsService.ID_TWO_DOCS_SHORT_NAME:
      case ConstantsService.ID_ONE_DOC_DVS_SHORT_NAME:
      case ConstantsService.ID_TWO_DOCS_DVS_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/feature-flag-trust-276-post-send-request/bulk-request-template-rapidid-au-nz-mobileid.csv';
        break;
      case ConstantsService.QVC_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/feature-flag-trust-276-post-send-request/bulk-request-template-rapidid-qualification-verification.csv';
        break;
      case ConstantsService.NCC_PC_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/feature-flag/bulk-request-template-ncc-au-criminal-history.csv';
        break;
      case ConstantsService.NCC_MOJ_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-ncc-nz-criminal-history.csv';
        break;
      case ConstantsService.NCC_RTW_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-ncc-au-right-to-work.csv';
        break;
      case ConstantsService.NCC_BANKRUPTCY_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/feature-flag/bulk-request-template-ncc-bankruptcy-au-criminal-history.csv';
        break;
      case ConstantsService.AML_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-rapidid-global-aml.csv';
        break;
      case ConstantsService.BANNED_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-rapidid-au-banned-disqualified.csv';
        break;
      case ConstantsService.SMC_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-certn-global-social-media.csv';
        break;
      case ConstantsService.CV_SHORT_NAME:
        if (this.TRUST_1101_CENTRIC) {
          this.templateLink = `${XrefBulkUploadModalComponent.CENTRIC_BULK_UPLOAD_BASE}/bulk-request-template-certn-global-cred-verification.csv`;
        } else if (this.selectedBackgroundCheck?.flow_names?.length && this.selectedFlow &&
              this.selectedFlow?.short_name === ConstantsService.CV_SQ_SHORT_NAME) {
          this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-certn-global-edu-cred-verification-quantity.csv';
        } else {
          this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-certn-global-edu-cred-verification-highest.csv';
        }
        break;
      case ConstantsService.EDUV_SHORT_NAME:
        if (this.TRUST_1101_CENTRIC) {
          this.templateLink = `${XrefBulkUploadModalComponent.CENTRIC_BULK_UPLOAD_BASE}/bulk-request-template-certn-global-edu-verification.csv`;
        } else if (this.selectedBackgroundCheck?.flow_names?.length && this.selectedFlow &&
              this.selectedFlow?.short_name === ConstantsService.EDUV_SQ_SHORT_NAME) {
          this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-certn-global-edu-cred-verification-quantity.csv';
        } else {
          this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-certn-global-edu-cred-verification-highest.csv';
        }
        break;
      case ConstantsService.EMPV_SHORT_NAME:
        if (this.selectedBackgroundCheck?.flow_names?.length && this.selectedFlow &&
              (this.selectedFlow?.short_name === ConstantsService.EMPV_SQ_SHORT_NAME)) {
          this.templateLink = this.TRUST_1101_CENTRIC
            ? `${XrefBulkUploadModalComponent.CENTRIC_BULK_UPLOAD_BASE}/bulk-request-template-certn-global-employment-verification-quantity.csv`
            : 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-certn-global-employment-verification-quantity.csv';
        } else {
          this.templateLink = this.TRUST_1101_CENTRIC
            ? `${XrefBulkUploadModalComponent.CENTRIC_BULK_UPLOAD_BASE}/bulk-request-template-certn-global-employment-verification-coverage.csv`
            : 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-certn-global-employment-verification-coverage.csv';
        }
        break;
      case ConstantsService.EIVC_SHORT_NAME:
        this.templateLink = 'https://assets.xref.com/omni/bulk-upload/bulk-request-template-certn-global-eivc.csv';
        break;
      case ConstantsService.WWCC_SHORT_NAME:
        this.TRUST_1225_WWCC = this.permissions.isFeatureActivated('trust-1225-certn-wwcc');
        if(this.TRUST_1225_WWCC){
          this.templateLink = 'https://assets.xref.com/omni/bulk-upload/feature-flag-trust-1225-certn-wwcc-request/bulk-request-template-certn-au-wwcc.csv';
        }
        break;
      case ConstantsService.AU_ENHANCED_PUBLIC_RECORD_CHECK_SHORT_NAME:
        this.TRUST_1337_DIRECTORSHIP_CREDIT_CHECKS = this.permissions.isFeatureActivated(
          'trust-1337-directorship-credit-checks'
        );
        if (this.TRUST_1337_DIRECTORSHIP_CREDIT_CHECKS) {
          this.templateLink = `${XrefBulkUploadModalComponent.TRUST_1337_BULK_UPLOAD_BASE}/bulk-request-template-certn-au-public-record.csv`;
        }
        break;
      case ConstantsService.DIRECTORSHIP_CHECK_SHORT_NAME:
        this.TRUST_1337_DIRECTORSHIP_CREDIT_CHECKS = this.permissions.isFeatureActivated(
          'trust-1337-directorship-credit-checks'
        );
        if (this.TRUST_1337_DIRECTORSHIP_CREDIT_CHECKS) {
          this.templateLink = `${XrefBulkUploadModalComponent.TRUST_1337_BULK_UPLOAD_BASE}/bulk-request-template-certn-global-directorship.csv`;
        }
        break;
    }
  }

  cancel() {
    this.cancelWithFeatureFlag();
  }

  cancelWithFeatureFlag() {
    if (this.checkType == ConstantsService.REFERENCE_CHECK || this.checkType == ConstantsService.BACKGROUND_CHECK) {
      this.rbulkUpload.clearFile();
    }
    else {
      this.bulkUpload.clearFile();
    }
    this._bsModalRef.hide();
  }

  cancelLegacyFeature() {
    if (this.checkType == ConstantsService.REFERENCE_CHECK) {
      this.rbulkUpload.clearFile();
    } else {
      this.bulkUpload.clearFile();
    }
    this._bsModalRef.hide();
  }

  updateTable(event) {
    this.buttonCheck = event.buttonStatus;
    this.numberOfChecks = event.numberOfPeople;
    this.total = event.total;
  }

  updateMessage(newMessages) {
    if (newMessages.length === 0) this.messages = [];
    else this.messages = this.messages.concat(newMessages);
  }

  upload() {
    this.bulkRequestData.emit({total: this.total});
    this._bsModalRef.hide();
  }

  getForm() {
    return this.requestForm;
  }

}
